// スケジューラ稼働状況バナー
interface Props {
  running: boolean;
  taskCount: number;
}

export default function StatusBanner({ running, taskCount }: Props) {
  if (!running) {
    return (
      <div className="status-banner warn">
        ⏸️ スケジューラ停止中。ページを再読み込みしてください。
      </div>
    );
  }
  if (taskCount === 0) {
    return (
      <div className="status-banner warn">
        ⚠️ タスクが登録されていません。下のフォームから追加してください。
      </div>
    );
  }
  return (
    <div className="status-banner">
      ✅ 稼働中：{taskCount}件のタスクを監視しています（このページを開いたままにしてください）
    </div>
  );
}
